
export enum alergenosEnum {
    altramuz = "altramuz",
    apio = "apio",
    cacahuetes = "cacahuetes",
    crustaceos = "crustaceos",
    frutos_secos = "frutos-secos",
    gluten = "gluten",
    huevos = "huevos",
    lacteos = "lacteos",
    moluscos = "moluscos",
    mostaza = "mostaza",
    pescado = "pescado",
    sesamo = "sesamo",
    soja = "soja",
    sulfitos = "sulfitos"
}